<div class="flex flex-row">
    <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
  </div>
  <div class="top-panel p-16">
    <div class="flex flex-row justify-between">
      <div class="flex-col">
        <div class="fw-600 fs-24">
          {{'SUBSRIPTION.SUBSCRIPTION' | transloco }}
        </div>
        <div class="flex flex-row mt-24 mb-24">
          <div class="flex flex-row items-center mr-16 pb-16" *ngIf="tenantId">
            <span class="fw-400">{{ 'TOOLBAR.TENANT' | transloco }}</span>
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
              {{tenantId}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(tenantId)"></mat-icon>
            </span>
            <span class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetFilter()">
              {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
          </div>
        </div>
      </div>
      <button class="flex justify-center items-center context-menu-icon height menu-btn pl-6 pr-6" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'INSTANCE_LIST.FILTERS' | transloco}}</span>
      </button>
    </div>
    <div class="flex" *ngIf="!isLoading; else loadingIconShows">
      <div *ngIf="!showNoSubscription" class="flex flex-col border-radius p-24">
        <app-subscription-tenant [tenantData]="tenantDetailsData" [accountData]="subscriptionId"></app-subscription-tenant>
      </div>
    </div>
    <ng-template #loadingIconShows>
      <div class="flex flex-row justify-center items-center spinner">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </ng-template>
    <mat-card *ngIf="showNoSubscription && !isLoading" class="flex flex-col spinner-container spinner">
      <img class="mr-8 w-46 h-56 mb-16" src="/assets/images/Layer_2.png"/>
      <div>{{'SUBSRIPTION.SELECT_TENANT_FILTER' | transloco }}</div>
    </mat-card>
  </div>
  
  